import { ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'
import { deviceLayout } from 'styles/breakpoint'

export const StyledBreadcrumbs = styled.div`
  padding: 8px 0;
  background-color: ${(props: ThemeProps) => props.theme.colors.white};

  ${deviceLayout.pcLayout`
    padding: 8px 16px;
  `}
`

export const StyledSearchArea = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  min-height: 400px;
  flex-direction: column;
  align-items: center;
  padding-bottom: 80px;

  & > :not(:first-child) {
    z-index: 9;
  }
`

export const StyledCustomBackground = styled.div`
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;

  ${deviceLayout.pcLayout`
    height: 350px;
  `}

  ${deviceLayout.spLayout`
    height: 250px;
  `}

  background-image: url('/images/categoriesBackground.svg');
  background-position: 50% bottom;
  background-repeat: no-repeat;
  background-size: cover;
`

export const StyledContentContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;

  #categories-search {
    background-color: ${(props: ThemeProps) => props.theme.colors.white};
    min-width: 100%;
    box-shadow: 0px 0px 25px rgba(38, 38, 38, 0.08);
    ${deviceLayout.pcLayout`
      width: 568px;
    `}
  }
`

export const StyledCategoriesContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-bottom: 16px;

  ${deviceLayout.spLayout`
    padding: 0 12px;
  `}

  &[data-layout-type='long'] {
    padding-top: 8px;
  }
`

export const StyledCategoryWrapper = styled.div`
  position: relative;
  display: flex;
  width: 33.33%;
  height: auto;
  justify-content: center;
  padding: 0 8px;
  margin-top: 16px;
  color: ${(props) => props.theme.mbColors.gray};
  a {
    border: 0;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
  }

  .chevron-icon {
    display: none;
  }

  .content p {
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
  }

  ${deviceLayout.pcLayout`
    margin-top: 32px;
    width: 16.66%;
    padding: 0 16px;
  `}

  & > a {
    width: 100%;
    height: 133px;
    .banner {
      margin-bottom: 8px;
    }

    ${deviceLayout.pcLayout`
      height: 150px;
      padding: 16px;
      .banner {
        width: auto;
      }

      .content > p[data-size='sm'] {
        font-size: ${(props: ThemeProps) => props.theme.sizes.fsHeading6};
        line-height: 22px;
      }
    `}
  }

  &[data-layout-type='long'] {
    width: 100%;
    margin-top: 8px;
    & > a {
      align-items: center;
    }

    .content p {
      text-align: left;
    }

    ${deviceLayout.spLayout`
        & > a {
            box-shadow: none;
        }
        .chevron-icon {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 14px;
            margin: auto;
            display: block;
        }

       .content {
            text-align: left;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex: 1;
            border-bottom: 1px solid #f3f3f3;
            height: 100%;
            margin: auto;
                p {
                    font-size: 14px;
                    margin: 30px 0px 30px 12px;
                }
        }
    `}

    ${deviceLayout.pcLayout`
      width: 33.33%;
      margin-top: 32px;
    `}

    & > a {
      display: flex;
      height: auto;
      flex-direction: row;

      .banner {
        width: auto;
        height: auto;
        padding: 0 8px;
        margin-bottom: 0;

        ${deviceLayout.pcLayout`
          margin-right: 16px;
        `}
      }
    }
  }
`
